export default __webpack_public_path__ + "static/media/abstract_box_goat.c70e5d9e.jpg";